import { useRecordContext } from 'react-admin'
export const SeCode = () => {
	const record = useRecordContext()
	return record ? (
		`
<iframe src="https://labs.competitor.com/result/subevent/${record.SubEventId}" importance="high" loading="lazy" frameborder="0" style="width: 100%; height: 667px;" height="100%" width="100%"></iframe>
			`
	) : ''
}
export default SeCode